import AccordionText from "../Utils/AccordionText"
import AddToCart from "./AddToCart";
import Attribute from "./Attribute"
import { ProductDetailItemProps, ProductVariantItemProps } from "./constants"
import { useEffect, useState } from "react";
import Cart from "../Cart";
import { CURRENCY_OPTIONS } from "../Common/GlobalVars";
import Image from 'next/image';
import SizeGuide from "./SizeGuide";
import { useAttributesStore } from "@/stores/useAttributesStore";


interface ProductDetailWithAttrProps extends ProductDetailItemProps {
  setVariantId: (setVariantId: number) => void;
}

const Detail = (props: ProductDetailWithAttrProps) => {
  const { attributes, getAttributes } = useAttributesStore();
  const [variant, setVariant] = useState<ProductVariantItemProps | null>(null);
  const [showCart, setShowCart] = useState(false);
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [attributesData, setAttributesData] = useState(getAttributes());
  const [open, setOpen] = useState(false);

  const show_add_to_cart = () => {
    if (variant !== null && variant !== undefined && variant.qty > 0) {
      setOpen(true);
    }
  }

  const displaySizeGuide = () => {
    setShowSizeGuide(true);
  }

  useEffect(() => {
    setAttributesData(getAttributes());
  }, [getAttributes, attributes])

  useEffect(() => {
    if (variant === null || variant === undefined) {
      props.setVariantId(0);
    } else {
      props.setVariantId(variant.variant_id);
    }
  }, [variant, props])

  return (
    <div>
      <div className="hidden md:block text-xs text-[#C6C6C6] font-dmsans font-normal">{props.product_code}</div>
      <h1 className="text-2xl md:text-[32px] text-[#2C3E2F] font-dmsans font-bold md:mt-2 leading-9 mt-8 capitalize">{props.name}</h1>
      <div className="flex justify-between">
        <div className="text-base md:text-xl text-[#2C3E2F] font-dmsans font-medium md:mt-2 leading-9">
          {process.env.NEXT_PUBLIC_CURRENCY}{variant === null || variant === undefined ? props.special_price.toLocaleString("en-US", CURRENCY_OPTIONS) : variant.special_price !== 0 ? variant.special_price.toLocaleString("en-US", CURRENCY_OPTIONS) : variant.sales_price.toLocaleString("en-US", CURRENCY_OPTIONS)}
          {props.special_price < props.msrp && (
            <>
              <br />
              <p className="text-[#C0C0C0] text-sm font-medium line-through leading-9">{process.env.NEXT_PUBLIC_CURRENCY}{props.msrp.toLocaleString("en-US", CURRENCY_OPTIONS)}</p>
            </>
          )}
          {(props.msrp === undefined || props.msrp === null || props.msrp === 0) && props.special_price < props.sales_price && (
            <>
              <br />
              <p className="text-[#C0C0C0] text-sm font-medium line-through leading-9">{process.env.NEXT_PUBLIC_CURRENCY}{props.sales_price.toLocaleString("en-US", CURRENCY_OPTIONS)}</p>
            </>
          )}
        </div>
        <div className="md:hidden text-xs text-[#C6C6C6] font-dmsans font-normal leading-9">{props.product_code}</div>
      </div>
      <Attribute
        product_code={props.product_code}
        attribute_value_list={props.attribute_value_list}
        product_variant_list={props.product_variant_list}
        attributes={attributesData.data}
        style="normal"
        variant={variant}
        setVariant={setVariant}
      />
      {variant !== null && variant !== undefined && variant.qty === 0 && (
        <div className="text-[#FF6464] text-base font-dmsans leading-9 italic my-4">Sorry, our product is out of stock.</div>
      )}
      {((props.size_guide.category !== null && props.size_guide.category !== undefined) ||
        (props.size_guide.image !== null && props.size_guide.image !== undefined) ||
        (props.size_guide.measure !== null && props.size_guide.measure !== undefined) ||
        (props.size_guide.suggestion !== null && props.size_guide.suggestion !== undefined)) && (<button
        className="mt-4 p-2 bg-[#FCFCF8] shadow-md flex"
        onClick={displaySizeGuide}
      >
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/size-guide.svg"}
          alt="size guide icon"
          width={20}
          height={20}
          quality={100}
        />
        <p className="ml-2 text-sm text-[#2C3E2F] font-dmsans">Size Guide</p>
      </button>)}
      <div
        className={`w-full mt-8 md:w-[400px] p-2 text-center text-white text-base font-dmsans font-normal ${variant !== null && variant !== undefined && variant.qty === 0 ? "bg-[#BABABA]" : "bg-[#A6CAA6] cursor-pointer"}`}
        onClick={show_add_to_cart}
      >
        Add To Cart
      </div>
      <div className="mt-8">
        {props.description_list.map((desc, index) => (
          <div key={index}>
            {desc.title === "" && (
              <p className="font-dmsans font-normal text-base text-[#2C3E2F] leading-6 mb-8" dangerouslySetInnerHTML={{__html: desc.description.replace(/(?:\r\n|\r|\n)/g, "<br />")}}></p>
            )}
            {desc.title != "" && <AccordionText
              title={desc.title}
              title_style="text-[#2C3E2F] font-dmsans text-sm font-semibold"
              description={desc.description}
              desc_style="font-dmsans font-normal text-base text-[#2C3E2F] leading-6"
            />}
          </div>
        ))}
      </div>
      <Cart isVisible={showCart} setIsVisible={setShowCart} />
      <SizeGuide
        size_guide={props.size_guide}
        isVisible={showSizeGuide}
        setIsVisible={setShowSizeGuide}
      />
      <AddToCart
        id={props.id}
        name={props.name}
        msrp={props.msrp}
        sales_price={props.sales_price}
        product_code={props.product_code}
        qty={props.qty}
        image={props.image_gallery[0].image}
        attribute_value_list={props.attribute_value_list}
        product_variant_list={props.product_variant_list}
        special_price={props.special_price}
        attributes={attributesData.data}
        brand={props.brand}
        slug={props.slug}
        style="popup"
        variant={variant}
        setVariant={setVariant}
        setShowCart={setShowCart}
        action="add"
        open={open}
        setOpen={setOpen}
      />
    </div>
  )
}

export default Detail
